import { HTMLTable, Spinner } from '@blueprintjs/core';
import * as React from 'react';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import MakeModel, {
  IMakeModelVehicle,
  MakeModelChange
} from '../components/MakeModel';
import firebase from '../firebase';
import { firestore } from '../firebase';
import { IState } from '../store';

const InventoryContainer = styled('main')`
  flex-direction: row;
  position: fixed;
  left: 25%;
`;
const MakeModelContainer = styled('section')`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;
const TableContainer = styled('section')`
  flex: 3;
`;

const getAvailableMakeModelsForTable = firebase
  .functions()
  .httpsCallable('getAvailableMakeModelsForTable');
const getVehiclesForTable = firebase
  .functions()
  .httpsCallable('getVehiclesForTable');

// const niceName = (name: string) =>
//   name.replace(/\_/gm, ' ').replace(/\%/gm, '/');

class Tables extends React.PureComponent<any, any> {
  public weekAgo = Date.now() - 604800000;
  public dayAgo = Date.now() - 86400000;

  public batchIncrement = 400;
  public batchStart = 0;
  public batchSize = 0;

  constructor(props) {
    super(props);

    this.state = {
      available: {},
      loading: false,
      make: '',
      model: '',
      search: [],
      vehicles: [],
      yearMax: null,
      yearMin: null
    };
  }

  public async componentDidMount() {
    const params = this.props.match.params;
    if (params.business) {
      const query = await firestore
        .collection('businesses')
        .where('path', '==', params.business)
        .get();
      const businessDoc = query.docs[0].data();

      if (params.site && params.site !== '-') {
        const siteQuery = await query.docs[0].ref
          .collection('sites')
          .where('path', '==', params.site)
          .get();
        const siteDoc = siteQuery.docs[0].data();
        const available = await getAvailableMakeModelsForTable({
          s3Id: siteDoc.s3Id
        });
        this.setState({ available: available.data, s3Id: siteDoc.s3Id });
      } else {
        const available = await getAvailableMakeModelsForTable({
          s3Id: businessDoc.s3Id
        });
        this.setState({ available: available.data, s3Id: businessDoc.s3Id });
      }
    }
  }

  public render() {
    const { loading, vehicles } = this.state;
    return (
      <InventoryContainer>
        <MakeModelContainer>
          <MakeModel
            available={this.state.available}
            onChange={this.handleMakeModelChange}
          />
        </MakeModelContainer>
        {loading ? (
          <Spinner />
        ) : (
          <TableContainer>
            <HTMLTable>
              <thead>
                <tr>
                  <th>MAKE</th>
                  <th>MODEL</th>
                  <th>YEAR</th>
                  <th>ROW</th>
                  <th>VIN</th>
                  <th>DATE ADDED</th>
                </tr>
              </thead>
              <tbody>
                {vehicles.map((data, index) => {
                  return this.renderCarRow(data, index);
                })}
              </tbody>
            </HTMLTable>
          </TableContainer>
        )}
      </InventoryContainer>
    );
  }

  private getS3Vehicles = async (s3Id: string, make: string, model: string) => {
    this.setState({ loading: true });
    console.log('searching S3...');
    const query = await getVehiclesForTable({ s3Id, make, model });
    console.log('VEHICLES: ');
    console.log(query);
    this.setState({ loading: false, vehicles: query.data });
  };
  private renderCarRow = (car, index) => {
    const make = car.MAKE[0];
    const model = car.MODEL[0];
    const year = car.iYEAR[0];
    const row = car.VEHICLE_ROW[0];
    const vin = car.VIN[0];
    const d = new Date(car.YARD_DATE[0]);
    const date = d.toLocaleDateString('en-US');

    return (
      <tr key={index}>
        <td>{make}</td>
        <td>{model}</td>
        <td>{year}</td>
        <td>{row}</td>
        <td>{vin}</td>
        <td>{date}</td>
      </tr>
    );
  };

  private handleMakeModelChange = (
    { make, model }: IMakeModelVehicle,
    change: MakeModelChange
  ) => {
    this.setState({ make, model });
    if (make !== null && model !== null) {
      this.getS3Vehicles(
        this.state.s3Id,
        make.toUpperCase(),
        model.toUpperCase()
      );
    }
  };
}

const mapStateToProps = ({ inventory: { vehicles } }: IState) => ({ vehicles });

const mapDispatchToProps = {};

export default connect<any, any>(
  mapStateToProps,
  mapDispatchToProps
)(Tables);



// WEBPACK FOOTER //
// ./src/views/Tables.tsx